import React from 'react';

const EmailWrap = ({ email }) => {
  return (
    <a href={`mailto:${email}`}>
      {email.split('@')[0]}
      {/* allows word wrap to happen at @ sign */}
      <wbr />
      {`@${email.split('@')[1]}`}
    </a>
  );
};

export default EmailWrap;
